import React, { useEffect, useState } from "react"
import API from "../../api"
import PropTypes from "prop-types"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withTranslation } from "react-i18next"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"
import { AvForm } from "availity-reactstrap-validation"
import "rc-checkbox/assets/index.css"
const HistoriqueUser = props => {
  const [disbutReg, setDisbutReg] = useState(true)
  const [array, setArray] = useState([])
  const [sections, setSections] = useState([]);
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  useEffect(async () => {
    const fetchData = async () => {
      const url = window.location.href;
      const parts = url.split("=");
      const id = parts[1];
      try {
        const res = await API.post("User/get_by_user_id", { user_id: id, annee_id: 4 });
        setSections(res.data.Historique_user || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                <Row>
                    {sections.map((section, sIdx) => {
                      const rows = section.array || [];
                      const cols = rows.length > 0 ? Object.keys(rows[0]) : [];
                      return (
                        <div key={sIdx} className="mb-4">
                          <table className="table table-bordered table-striped">
                            <thead>
                            <tr className="table-primary">
                              <th colSpan={Math.max(1, cols.length)} className="text-center">
                                {section.name}
                              </th>
                            </tr>
                            {cols.length > 0 && (
                              <tr>
                                {cols.map((c) => (
                                  <th key={c}>{c}</th>
                                ))}
                              </tr>
                            )}
                            </thead>

                            <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td colSpan={Math.max(1, cols.length)} className="text-center text-muted">
                                  Aucun enregistrement trouvé
                                </td>
                              </tr>
                            ) : (
                              rows.map((row, rIdx) => (
                                <tr key={rIdx}>
                                  {cols.map((c) => (
                                    <td key={c}>{row[c] !== null && row[c] !== undefined ? row[c] : "-"}</td>
                                  ))}
                                </tr>
                              ))
                            )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                </Row>
                <Row>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    {" "}
                    <Col lg="6">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        className="text-center mt-4"
                      >
                        <Button
                          type="button"
                          color="warning"
                          className="btn btn-warning  mb-2 me-2"
                          onClick={() => props.history.push("/User")}
                        >
                          {props.t("Annuler")}
                        </Button>
                      </div>
                    </Col>

                  </div>
                </Row>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(HistoriqueUser)
HistoriqueUser.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
